angular.module('ControllersModule')
  .controller('LoaderDialogController', function ($scope, LoaderDialogFactory) {
  
  $scope.loaderDialogComplete = function(data) {
    LoaderDialogFactory.loaderDialogComplete(data);
  }
});